import React, { Fragment } from 'react';
import { useDeliveryOptions, useEntyTypes, useGetUtilsKeys, useListTerceros } from '../../../../share';
import { Row, Col, Button, Divider } from 'antd';
import { FormSelect, FormInput, FormDatePicker, CustomText } from '../../../../components';
import dayjs from 'dayjs';

const AdvancedFilters: React.FC<any> = ({ formik, filters, setFilters }: any) => {
  const [filterSelected, setFilterSelected] = React.useState<{ name: string, id: string, type: string, fetchData?: any[] }>();
  
  const { data: entyTypes } = useEntyTypes();
  const { data: entryDevelivery } = useDeliveryOptions();
  const storedToken = localStorage.getItem('auth');
  const parsedToken = storedToken ? JSON.parse(storedToken) : null;
  const token = parsedToken?.authorization?.token;
  const { data, isLoading, error } = useListTerceros(token);
  const terceros = data?.third_party || [];

  const { data: utilKeys = [] } = useGetUtilsKeys(
    'keys[]=sectionals&keys[]=dependencies&keys[]=asset_type',
  );

  const filterOptions = [
    { name: 'Tipo de entrada', id: 'entry_type', type: 'select', fetchData: entyTypes },
    { name: 'Cantidad entregas estipuladas', id: 'deliveries', type: 'number' },
    { name: 'Seccional entrada', id: 'entry_section_id', type: 'select', fetchData: utilKeys?.sectionals || [] },
    { name: 'Tipo de bien', id: 'item_type', type: 'select', fetchData: utilKeys?.asset_type || [] },
    { name: 'Dependencia', id: 'dependency_id', type: 'select', fetchData: utilKeys?.dependencies || [] },
    { name: 'Entregas en otras seccionales', id: 'other_deliver', type: 'select', fetchData: entryDevelivery },
    { name: 'Número de: factura/oficio/peritaje/Doc. equivalente/Avalúo/Informe', id: 'invoice_number', type: 'number' },
    { name: 'Fecha de: factura/oficio/peritaje/Doc. equivalente/Avalúo/Informe', id: 'invoice_date', type: 'date' },
    { name: 'Cantidad de facturas', id: 'invoice_count', type: 'number' },
    { name: 'Supervisor', id: 'supervisor', type: 'text' },
    { name: 'Valor factura/adquisición/Avalúo/Peritaje', id: 'entry_value', type: 'text'},
    { name: 'Número de orden de compra', id: 'purchase_order', type: 'text'},
    { name: 'Número de contrato', id: 'contract_number', type: 'text'},
    { name: 'Fecha inicio contrato', id: 'contract_start_date', type: 'date'},
    { name: 'Fecha final contrato', id: 'contract_end_date', type: 'date'},
    { name: 'Documento de donación', id: 'donation_document', type: 'text'},
    { name: 'Juzgado de conocimiento', id: 'judgment_court_name', type: 'select', fetchData: terceros},
    { name: 'Fiscalía', id: 'decomiso_court_number', type: 'text'},
    { name: 'Noticia criminal - comiso', id: 'judgment_process_number', type: 'text'},
    { name: 'Número de contrato comodato', id: 'comodato_contract_number', type: 'text'},
    { name: 'Fecha inicio de contrato comodato', id: 'comodato_start_date', type: 'date'},
    { name: 'Fecha final de contrato comodato', id: 'comodato_end_date', type: 'date'},
    { name: 'Número de Acuerdo interadministrativo', id: 'interadmin_agreement_number', type: 'number'},
    { name: 'Fecha inicial acuerdo interadministrativo', id: 'interadmin_start_date', type: 'date'},
    { name: 'Fecha final acuerdo interadministrativo', id: 'interadmin_end_date', type: 'date'},
    { name: 'Noticia criminal - incautado con fines de comiso', id: 'decomiso_process_number', type: 'number'},
  ];

  const handleAddFilter = () => {
    let item = {value: formik.values.filter_value, name: '', filter: {...filterSelected}};

    if (filterSelected?.type === 'date') {
      item.value = dayjs(formik.values.filter_value).format('YYYY-MM-DD');
    }

    if (filterSelected?.type === 'select') {
      item.name = filterSelected?.fetchData?.find((value) => value.id === formik.values.filter_value)?.name;
    }

    setFilters({...filters, [formik.values.filter_id]: item})

    setFilterSelected(undefined);
    formik.setFieldValue('filter_value', undefined);
    formik.setFieldValue('filter_id', undefined);
  };

  const handleRemoveFilter = (filterId: string) => {
    const filtersCopy = {...filters};
    delete filtersCopy[filterId];

    setFilters({...filtersCopy});
  };

  return (
    <Fragment>
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={12}>
          <FormSelect
            label="Seleccionar filtro"
            name="select_filter"
            placeholder="Seleccionar..."
            value={formik.values.filter_id}
            options={filterOptions}
            error={formik.errors.filter_id}
            touched={formik.touched.filter_id}
            onChange={(value) => {
              setFilterSelected(filterOptions.find(item => item.id === value));
              formik.setFieldValue('filter_value', '');
              formik.setFieldValue('filter_id', value);
            }}
            onBlur={formik.handleBlur}
          />
        </Col>
        <Col xs={24} sm={12}>
          {filterSelected?.type === 'select' && (
            <FormSelect
              label=""
              name="filter_value"
              placeholder="Seleccione"
              value={formik.values.filter_value}
              options={filterSelected?.fetchData || []}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={(value) => formik.setFieldValue('filter_value', value)}
              onBlur={formik.handleBlur}
            />
          )}
          {filterSelected?.type === 'text' && (
            <FormInput
              label={''}
              name="filter_value"
              placeholder="Ingrese valor"
              value={formik.values.filter_value}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          )}
          {filterSelected?.type === 'number' && (
            <FormInput
              label={''}
              name="filter_value"
              placeholder="Ingrese valor"
              value={formik.values.filter_value}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          )}
          {filterSelected?.type === 'date' && (
            <FormDatePicker
              label=""
              name="filter_value"
              value={formik.values.filter_value}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={(value) => formik.setFieldValue('filter_value', value)}
              onBlur={formik.handleBlur}
            />
          )}
        </Col>

        <Col xs={24} style={{ textAlign: "right", marginTop: 8, width: '100%' }}>
          <Button type="dashed" disabled={!formik.values.filter_value || !formik.values.filter_value} onClick={handleAddFilter} style={{ minWidth: 120 }}>
            Agregar Filtro
          </Button>
        </Col>
      </Row>
      <Divider />
      {Object.keys(filters).map((filterId: string) => {
        return (
          <Row gutter={[16, 16]} align="middle" key={filterId}>
            <Col xs={12}><CustomText strong={true} text={filters[filterId]?.filter.name} /> </Col>
            <Col xs={1}><CustomText strong={true} text="=" /> </Col>
            <Col xs={7}><CustomText text={filters[filterId]?.name || filters[filterId]?.value} /> </Col>
            <Col xs={4} style={{ textAlign: "right" }}><Button type="link" onClick={() => handleRemoveFilter(filterId)}>Eliminar</Button></Col>
          </Row>
        );
      })}
      {!Object.keys(filters).length && (<CustomText strong={true} centered={true} text="No tiene filtros agregados" />)}
    </Fragment>
  );
};

export default AdvancedFilters;
